import { ExcelDataService } from '../../DataService/ExcelDataService';
import { CommonHelper } from '../../Helpers/CommonHelper';
import { ModalHelper } from '../../Helpers/ModalHelper';

export class ProcessEnquiryManager {

    constructor(private containerElement: JQuery) { }

    private processedWorkbookId;
    private createEnquiryInfoModal : ModalHelper; 

    public initialize() {
        var self = this;

        self.processedWorkbookId = self.containerElement.data('processed-workbook-id');

        this.createEnquiryInfoModal = new ModalHelper();
        this.createEnquiryInfoModal.createModal("create-enquiry-info-popup", true);

        (<any>window).initializeProcessEnquiry = () => {
            self.bindEvents();
        }

        self.bindEvents();
    }


    private bindEvents() {
        var self = this;

        var createEnquiryButton = $('button[form="process-enquiry-form"]');
        var createEnquiryForm = $('#process-enquiry-form');

        createEnquiryButton.off('click').on('click', () => {
            createEnquiryButton.prop('disabled', true);

            ExcelDataService.canCreateEnquiryFromProcessedWorkbook(self.processedWorkbookId, (result) => {
                if(result) {
                    createEnquiryForm.trigger('submit');
                }
                else {
                    self.createEnquiryInfoModal.load(`?processedWorkbookId=${self.processedWorkbookId}&handler=CantCreateEnquiryInfo`);
                    createEnquiryButton.prop('disabled', false);
                    //load error
                }
            })
        })



        $('.impa-popover').each((index, element) => {
            var impaPopover = $(element);
            var lineId = impaPopover.closest('tr').data('line-id');

            var impaCode = impaPopover.data('impa-code');
            var impaDescription = impaPopover.data('impa-description');
            var impaPercentageClass = impaPopover.data('impa-percentage-class');
            var impaPercentage = impaPopover.data('impa-percentage');


            impaPopover.popover({
                html: true,
                trigger: "click",
                placement: 'bottom',
                container: '#view-container',
                customClass: "impa-popover-container",
                fallbackPlacements: ['top', 'bottom'],
                title: `<div class="impa-heading-container" id="impa-heading-container">
                    <div class="impa-popup-code-text"><label>${impaCode}</label></div>
                    <div class="impa-popup-percentage-container ${impaPercentageClass}">
                        <label>Match ${impaPercentage}%</label>
                    </div>
                </div>`,
                sanitize: false,
                content: 
                `<div id="impa-info-container">
                    <p class="mb-1">${impaDescription}</p>
                    <button class="btn btn-xs w-100 btn-danger text-center" type="button" data-action="remove-impa-button">
                        Remove impa
                    </button>
                </div>
                <div class="d-none" id="confirm-remove-container" >
                    <p>Are you sure you want to remove this IMPA? This action cannot be reverted,</p>
                    <div class="d-flex justify-content-between mt-1">
                        <button class="btn btn-xs btn-secondary text-center" type="button" data-action="cancel-remove-impa-button">
                            Cancel
                        </button>
                        <button class="btn btn-xs btn-primary text-center" type="button" data-action="confirm-remove-impa-button">
                            Confirm
                        </button>
                    </div>
                </div>`,
            })
            .on("inserted.bs.popover", () => {
                var popoverId = impaPopover.attr('aria-describedby');
                var popover = $(`#${popoverId}`);

                var removeButton = popover.find('button[data-action="remove-impa-button"]');
                var cancelButton = popover.find('button[data-action="cancel-remove-impa-button"]');
                var confirmButton = popover.find('button[data-action="confirm-remove-impa-button"]');

                var removeInfoContainer = popover.find('#confirm-remove-container');
                var impaInfoContainer = popover.find('#impa-info-container');
                removeButton.off('click').on('click', () => {
                    impaInfoContainer.addClass('d-none');
                    removeInfoContainer.removeClass('d-none');

                    removeButton.prop('disabled', true)
                })

                cancelButton.off('click').on('click', () => {
                    removeInfoContainer.addClass('d-none');
                    impaInfoContainer.removeClass('d-none');

                    removeButton.prop('disabled', false)
                })

                confirmButton.off('click').on('click', () => {
                    impaPopover.popover('hide');
                    ExcelDataService.deleteProcessedLineImpaCode(lineId, (result) => {
                        if(result) {
                            impaPopover.remove();
                        }
                    })
                })
            });
        })

        $('body').on('click', function (e) {
            if ($(e.target).data('toggle') !== 'popover'
                && $(e.target).parents('.popover').length === 0) { 
                $('[data-bs-toggle="popover"]').popover('hide');
            }
        });
        
        document.addEventListener('scroll', function (event) {
            $('[data-bs-toggle="popover"]').popover('hide');
        }, true /*Capture event*/);
    }


}